// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3HH-p","title":"InfoRow_title__3ZP_m"};